import { Component, Input } from '@angular/core';

@Component({
    selector: 'ah-loading-overlay',
    templateUrl: './loading-overlay.component.html',
    styleUrls: ['./loading-overlay.component.scss'],
    standalone: false
})
export class LoadingOverlayComponent {
    @Input() isVisible: boolean;

    constructor() { }
}
